import { InstallLatestCommand } from './commands/install-latest.command';
import { ShellCommand } from './commands/shell.command';
import { WriteFileCommand } from './commands/writeFile.command';
import { WriteInstallFileCommand } from './commands/writeInstallFile.command';
import { Procedure } from './procedure.interface';
import { RESET_COMMANDS } from './reset';

export const INSTALL_KRYS_OR_CDL = (isCdl: boolean): Procedure => {
  return {
    name: isCdl ? 'CDL' : 'Krys',
    resetCommands: RESET_COMMANDS,
    commands: [
      new InstallLatestCommand('KRYS'),
      new InstallLatestCommand('UPDATER'),
      new WriteFileCommand('/sdcard/config.txt', 'open_guide:0\n------\nhome_pkg:fr.eyesoft.krys.app\n------\n'),
      new ShellCommand('mkdir -p /storage/emulated/0/Android/data/fr.eyesoft.krys.app/files'),
      new WriteFileCommand(
        '/storage/emulated/0/Android/data/fr.eyesoft.krys.app/files/settings.json',
        `{ "corporation": "${isCdl ? 'CDL' : 'KRYS'}" }`,
      ),
      new ShellCommand('setprop persist.pxr.force.home fr.eyesoft.krys.app,com.unity3d.player.UnityPlayerNativeActivityPico'),
      new WriteInstallFileCommand('/storage/emulated/0/Android/data/fr.eyesoft.krys.app/files'),
    ],
    validationCommands: [],
  };
};
